import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import CbtVenueSelectionForm from '@cont/SeeAll/TestSeriesListing/TestSeriesRevamp/CbtVenueSelectionForm';

const VenueWrapper = styled.div`
  margin-top: ${Spacings.SPACING_6B};
  margin-bottom: 200px;
  padding: ${Spacings.SPACING_6B};
  background-color: var(--color-base-1);
  border: 1px solid var(--color-divider);
  border-radius: ${Spacings.SPACING_4B};
  text-align: left;

  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_4B};
    margin-bottom: 240px;
    padding: ${Spacings.SPACING_4B};
    border-radius: ${Spacings.SPACING_2B};
  }
`;

const Title = styled(Typography)`
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Fonts.H4};
  line-height: 30px;
  margin-bottom: ${Spacings.SPACING_6B};

  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H5};
    line-height: 26px;
    margin-bottom: ${Spacings.SPACING_4B};
  }
`;

const BundleCbtVenueSelection = ({
  programmeUid,
  onVenueChange,
  isMobile = false
}) => {
  if (!programmeUid) return null;

  return (
    <VenueWrapper>
      <Title variant="h4">Fill your details</Title>
      <CbtVenueSelectionForm
        programmeUid={programmeUid}
        isMobile={isMobile}
        hideProceedButton
        onVenueChange={onVenueChange}
      />
    </VenueWrapper>
  );
};

export default BundleCbtVenueSelection;
